// Registry of sections that use the generic ContentPage.vue template.
// Add an entry here to make a new section's markdown files routable —
// see docs/features/18-content-page-template.md for the full pattern.
// Each entry needs a matching folder at src/content/pages/<key>/*.md.
// Do not set backTo to /our-work, /resources, /about/news, or /resources/training —
// those are reserved by the existing collection routes. Reusing one here would
// generate a duplicate route that vue-router never reaches (the pre-existing
// collection route always wins), silently 404-ing every page in that section.
export const CONTENT_PAGE_SECTIONS = [
  { key: 'about',       label: 'About',       backTo: '/about',       backLabel: 'About' },
  { key: 'the-academy', label: 'The Academy', backTo: '/the-academy', backLabel: 'The Academy' },
]
